/** Quiet decorative light points; each settles once and never intercepts controls. */
export default function MotionSparkles() {
  return (
    <span className="gp-motion-sparkles" aria-hidden="true">
      {Array.from({ length: 7 }, (_, index) => (
        <span key={index} data-gp-reveal="sparkle" aria-hidden="true" />
      ))}
    </span>
  );
}
